import { Download, NotebookPen, Printer } from 'lucide-react';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const READING_LISTS = [
  { id: 'reading-list-1', label: 'След 1. клас' },
  { id: 'reading-list-2', label: 'След 2. клас' },
  { id: 'reading-list-3', label: 'След 3. клас' },
  { id: 'reading-list-4', label: 'След 4. клас' },
];

const download = (id) => window.open(`${API_URL}/library/materials/${id}/download`, '_blank');

export const MaterialsSection = () => {
  return (
    <section id="materials" data-testid="materials-section" className="max-w-7xl mx-auto px-4 sm:px-6 pb-16 scroll-mt-20">
      <div className="rounded-3xl bg-gradient-to-br from-[#e8f5ef] via-[#fdf6ea] to-amber-50 border border-amber-200/60 p-6 sm:p-10 overflow-hidden">
        <div className="flex items-center gap-3 mb-1">
          <div className="w-10 h-10 rounded-xl bg-amber-500 flex items-center justify-center shrink-0">
            <Printer className="h-5 w-5 text-white" />
          </div>
          <h2 className="library-font text-xl sm:text-2xl font-bold text-stone-800">Свали и принтирай</h2>
        </div>
        <p className="text-sm text-stone-500 mb-8 ml-13 sm:ml-[52px]">Безплатни материали за малките читатели и техните родители</p>

        <div className="grid lg:grid-cols-2 gap-8">
          {/* Читателски дневник */}
          <div
            data-testid="material-card-reader-diary"
            className="group flex gap-5 bg-white/80 rounded-2xl p-5 border border-amber-200/70 shadow-sm hover:shadow-lg transition-shadow cursor-pointer"
            onClick={() => download('reader-diary')}
          >
            <img
              src={`${API_URL}/library/materials/reader-diary/preview`}
              alt="Читателски дневник"
              loading="lazy"
              className="w-28 sm:w-36 rounded-lg shadow-md object-contain self-start transition-transform duration-300 group-hover:-rotate-2 group-hover:scale-105"
            />
            <div className="flex flex-col">
              <div className="inline-flex items-center gap-2 text-[#00966E] text-xs font-bold uppercase tracking-wide">
                <NotebookPen className="h-3.5 w-3.5" /> Моят читателски дневник
              </div>
              <h3 className="library-font font-bold text-stone-800 text-lg mt-1.5 leading-snug">
                Записвай всяка прочетена книга
              </h3>
              <p className="text-sm text-stone-500 mt-2 leading-relaxed flex-1">
                Принтирай дневника и отбелязвай заглавието, автора, любимия си герой и какво те е впечатлило. Чудесен спомен от всяка книга!
              </p>
              <button
                data-testid="download-diary-btn"
                className="mt-4 inline-flex items-center gap-2 self-start px-5 py-2.5 rounded-full bg-[#00966E] text-white text-sm font-semibold hover:bg-[#007a59] transition-colors"
              >
                <Download className="h-4 w-4" /> Свали дневника (PDF)
              </button>
            </div>
          </div>

          {/* Препоръчителна литература */}
          <div>
            <h3 className="library-font font-bold text-stone-800 text-lg leading-snug">Препоръчителна литература</h3>
            <p className="text-sm text-stone-500 mt-1 mb-4">Какво да четем през ваканцията — списък за всеки клас</p>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
              {READING_LISTS.map((list) => (
                <button
                  key={list.id}
                  data-testid={`material-card-${list.id}`}
                  onClick={() => download(list.id)}
                  className="group/list relative rounded-xl overflow-hidden border border-amber-200/70 bg-white/80 shadow-sm hover:shadow-lg transition-shadow text-left"
                >
                  <img
                    src={`${API_URL}/library/materials/${list.id}/preview`}
                    alt={list.label}
                    loading="lazy"
                    className="w-full aspect-[3/4] object-cover object-top transition-transform duration-300 group-hover/list:scale-105"
                  />
                  <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-stone-900/85 to-transparent pt-8 pb-2.5 px-3 flex items-center justify-between">
                    <span className="text-white text-xs sm:text-sm font-bold library-font">{list.label}</span>
                    <span className="w-7 h-7 rounded-full bg-amber-500 flex items-center justify-center shrink-0">
                      <Download className="h-3.5 w-3.5 text-white" />
                    </span>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
